import BasicBlock from '../components/BasicBlock';
import TypeIcon from '../TypeIcon';
import { CardHeader } from '../components/CardHeader';
import { initiatorTypes } from '../../constants';
import { defaultAutomationString, defaultEmployeeString } from '../helpers';
import { useMemo } from 'react';

const getCardHeaderConfig = (action, instanceName) => (t) => {
  const prefix =
    action === 'granted'
      ? t('"My Records" access granted by')
      : t('"My Records" access revoked by');
  return {
    [initiatorTypes.employee]: {
      prefix,
      creationType: defaultEmployeeString,
    },
    [initiatorTypes.automation]: {
      prefix,
      creationType: defaultAutomationString,
    },
    [initiatorTypes.employee_api_request]: {
      prefix,
      creationType: defaultEmployeeString,
      postfix: t('via API'),
    },
    [initiatorTypes['empty-initiator']]: {
      prefix,
    },
  };
};

export const RecordAccessUpdateBlock = ({ event, ...others }) => {
  const cardHeaderConfig = useMemo(
    () =>
      getCardHeaderConfig(event.data.action, event?.instance?.entityRecordName),
    [event.data.action, event?.instance?.entityRecordName]
  );

  return (
    <BasicBlock
      comments={event.comments}
      icon={
        <TypeIcon
          color="var(--color-viz-cat-4-primary)"
          icon="id-card"
          size="16px"
        />
      }
      isDeletable={false}
      timestamp={event.created}
      title={
        <CardHeader
          event={event}
          name={event.data.teamMember.displayText}
          config={cardHeaderConfig}
        />
      }
      event={event}
      {...others}
    />
  );
};
